import { render } from "./ServicesReview.vue?vue&type=template&id=0eb69c68"
import script from "./ServicesReview.vue?vue&type=script&lang=js"
export * from "./ServicesReview.vue?vue&type=script&lang=js"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__